"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.COMPONENT_NAME = exports.getIconSize = exports.COLOR_THEME = exports.THEME = void 0;
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const next_components_icon_1 = __importDefault(require("@gerenciatd/next.components.icon"));
const next_components_custom_link_1 = __importDefault(require("@gerenciatd/next.components.custom-link"));
const next_utils_validators_1 = require("@gerenciatd/next.utils.validators");
const next_utils_metrics_1 = require("@gerenciatd/next.utils.metrics");
exports.THEME = {
    LINE: 'line',
    ROUNDED: 'rounded',
    BOX: 'box',
    FORM: 'form',
};
exports.COLOR_THEME = {
    WHITE: 'white',
};
const getIconSize = (inputType) => {
    switch (inputType) {
        case exports.THEME.LINE:
            return 24;
        case exports.THEME.ROUNDED:
            return 20;
        default:
            return 24;
    }
};
exports.getIconSize = getIconSize;
exports.COMPONENT_NAME = 'Input';
class Input extends react_1.Component {
    constructor(props) {
        super(props);
        this.validateInput = (value, saveValidation = true) => {
            const { validators } = this.state;
            const { error, pattern } = this.props;
            let validationObj = {
                validated: true,
                errorMsg: '',
            };
            validators.forEach((validator) => {
                if (validationObj.validated) {
                    validationObj = validator(value, this.props, pattern);
                }
            });
            if (!validationObj.errorMsg && error) {
                validationObj.errorMsg = error;
            }
            if (saveValidation) {
                this.setState({
                    error: validationObj.errorMsg,
                });
            }
            return validationObj;
        };
        this.handleOnFocus = () => {
            const { info, isReadOnly, taggingInfo = {}, name } = this.props;
            const finalTaggingInfo = Object.assign(Object.assign({}, taggingInfo), { componentVariation: taggingInfo.componentVariation || 'all', componentProduct: taggingInfo.componentProduct || '', componentName: taggingInfo.componentName || exports.COMPONENT_NAME, eventType: 'focus', componentContent: `input-${name}` });
            (0, next_utils_metrics_1.sendCMSEvent)(finalTaggingInfo);
            if (info && !isReadOnly) {
                this.setState({
                    showInfo: true,
                });
            }
            this.setState({
                toggleLabel: true,
                animatedBar: true,
            });
        };
        this.handleOnBlur = (event) => {
            const { onBlur, isAutocomplete } = this.props;
            const { value } = this.state;
            const eventObj = event;
            let currentValue = '';
            if (isAutocomplete && eventObj.relatedTarget) {
                currentValue = eventObj.relatedTarget.innerText || value;
            }
            else {
                currentValue = eventObj.currentTarget.value;
            }
            const validationObj = this.validateInput(currentValue);
            eventObj.validationObj = validationObj;
            let toggleLabel = false;
            if (currentValue) {
                toggleLabel = true;
            }
            this.setState({
                toggleLabel,
                animatedBar: false,
                value: currentValue,
            });
            if (onBlur) {
                onBlur(eventObj);
            }
        };
        this.setCssColorTheme = (colorTheme) => {
            return `e-skeletonInput--theme-${colorTheme}`;
        };
        this.handleChange = (event) => {
            const eventObj = event;
            const { onChange, saveOnChangeValidation } = this.props;
            const { value } = eventObj.currentTarget;
            const validationObj = this.validateInput(value, saveOnChangeValidation);
            eventObj.validationObj = validationObj;
            let toggleLabel = false;
            if (value) {
                toggleLabel = true;
            }
            this.setState({
                toggleLabel,
                animatedBar: false,
                value,
            });
            if (onChange) {
                onChange(eventObj);
            }
        };
        this.cleanInput = () => {
            const { cleanAction, error } = this.props;
            if (cleanAction) {
                cleanAction();
            }
            this.setState({
                value: '',
                toggleLabel: false,
                error,
            });
        };
        this.handleOnPaste = (e) => {
            e.preventDefault();
        };
        this.handleOnClickHideIcon = () => {
            const { showPassword } = this.state;
            this.setState({
                showPassword: !showPassword,
            });
        };
        const validators = [];
        const { required, minLength, maxLength, pattern, name, validators: validatorsArray, defaultValue, error, } = this.props;
        let toggleLabel = false;
        if (defaultValue) {
            toggleLabel = true;
        }
        if (required) {
            validators.push((0, next_utils_validators_1.getValidator)(next_utils_validators_1.validatorList.REQUIRED));
        }
        if (pattern) {
            validators.push((0, next_utils_validators_1.getValidator)(next_utils_validators_1.validatorList.PATTERN));
        }
        if (minLength > 0 || maxLength < 999) {
            validators.push((0, next_utils_validators_1.getValidator)(next_utils_validators_1.validatorList.LENGTH));
        }
        if (Array.isArray(validatorsArray)) {
            validatorsArray.forEach((validatorName) => {
                const validator = (0, next_utils_validators_1.getValidator)(validatorName);
                if (validator) {
                    validators.push(validator);
                }
                else {
                    console.warn(`Invalid validator: ${validatorName} in ${name}`);
                }
            });
        }
        this.state = {
            toggleLabel,
            error,
            value: defaultValue,
            validators,
            showPassword: false,
            showInfo: false,
        };
    }
    componentDidMount() {
        const { formSkeletonProps } = this.props;
        if (formSkeletonProps) {
            const { activateFormElement } = formSkeletonProps;
            if (activateFormElement) {
                activateFormElement();
            }
        }
    }
    shouldComponentUpdate(nextProps) {
        const { formSkeletonProps } = this.props;
        if (formSkeletonProps) {
            const { submitTries } = formSkeletonProps;
            if (submitTries < nextProps.formSkeletonProps.submitTries) {
                const { value } = this.state;
                const validationObj = this.validateInput(value);
                if (nextProps.error) {
                    validationObj.errorMsg = nextProps.error;
                    validationObj.validated = false;
                    this.setState({
                        error: nextProps.error,
                    });
                }
                const { validateFormElement } = formSkeletonProps;
                if (validateFormElement) {
                    validateFormElement(validationObj);
                }
                return false;
            }
        }
        const { error } = this.props;
        if (error !== nextProps.error) {
            this.setState({
                error: nextProps.error,
            });
            return false;
        }
        const { defaultValue } = this.props;
        if (defaultValue !== nextProps.defaultValue &&
            nextProps.defaultValue !== this.state.value) {
            this.setState({
                value: nextProps.defaultValue,
                toggleLabel: !!nextProps.defaultValue,
            });
            return false;
        }
        return true;
    }
    componentWillUnmount() {
        const { formSkeletonProps } = this.props;
        if (formSkeletonProps) {
            const { deactivateFormElement } = formSkeletonProps;
            if (deactivateFormElement) {
                deactivateFormElement();
            }
        }
    }
    render() {
        const { id, name, cleanButton, svgIconProps, theme, colorTheme, placeHolder, actionInput, autoComplete, taggingInfo, allowPaste, isReadOnly, inputDescription, toggleLabel: toggleLabelProp, pattern, className, showHideIcon, info, } = this.props;
        let { typeField } = this.props;
        const { showPassword, showInfo } = this.state;
        if (typeField === 'password' && showPassword) {
            typeField = 'text';
        }
        const { value, toggleLabel, animatedBar, error } = this.state;
        const inputThemeCss = this.setCssColorTheme(colorTheme);
        const inputTypeCss = `e-skeletonInput e-skeletonInput--${theme}`;
        const handleActionInput = () => {
            if (actionInput) {
                actionInput();
            }
        };
        let validationColor = 'blue';
        if (error) {
            validationColor = 'red';
        }
        if (isReadOnly) {
            validationColor = 'grey';
        }
        let labelCss = `e-skeletonInput__label e-skeletonInput__label--${validationColor}`;
        let barCss = `e-skeletonInput__bar--${validationColor}`;
        if (toggleLabel && toggleLabelProp) {
            labelCss = `${labelCss} toggleLabel`;
        }
        if (animatedBar) {
            barCss = `${barCss} animatedBar`;
        }
        const finalTaggingInfo = Object.assign(Object.assign({}, taggingInfo), { componentVariation: taggingInfo.componentVariation || 'all', componentProduct: taggingInfo.componentProduct || '', componentName: taggingInfo.componentName || exports.COMPONENT_NAME, componentContent: `input-${name}` });
        return (react_1.default.createElement("div", { className: `${inputTypeCss} ${inputThemeCss} ${className}` },
            svgIconProps && (react_1.default.createElement(next_components_custom_link_1.default, { className: "e-skeletonInput__icon", onClick: handleActionInput, taggingInfo: Object.assign(Object.assign({}, finalTaggingInfo), { componentContent: `${finalTaggingInfo.componentContent}-icon` }) },
                react_1.default.createElement(next_components_icon_1.default, Object.assign({}, svgIconProps, { size: (0, exports.getIconSize)(theme) })))),
            react_1.default.createElement("label", { htmlFor: id, className: labelCss }, placeHolder),
            react_1.default.createElement("div", { className: "e-skeletonInput__fieldWrapper" },
                react_1.default.createElement("input", { id: id, type: typeField, name: name, className: `e-skeletonInput__field e-skeletonInput__field--${validationColor}`, autoComplete: autoComplete, pattern: pattern, placeholder: placeHolder, onFocus: this.handleOnFocus, onChange: this.handleChange, onBlur: this.handleOnBlur, onPaste: allowPaste ? null : this.handleOnPaste, onKeyPress: this.handleKeyPress, value: value, readOnly: isReadOnly }),
                cleanButton && value && (react_1.default.createElement(next_components_custom_link_1.default, { forceExternal: true, className: "e-skeletonInput__actionIcon", onClick: this.cleanInput, taggingInfo: Object.assign(Object.assign({}, finalTaggingInfo), { componentContent: `${finalTaggingInfo.componentContent}-clean-icon` }) },
                    react_1.default.createElement(next_components_icon_1.default, { id: "Cerrar", kind: "L", size: 16 }))),
                showHideIcon && (react_1.default.createElement(next_components_custom_link_1.default, { forceExternal: true, className: "e-skeletonInput__actionIcon showPasswordIcon", onClick: this.handleOnClickHideIcon, taggingInfo: Object.assign(Object.assign({}, finalTaggingInfo), { componentContent: `${finalTaggingInfo.componentContent}-eye-icon` }) },
                    !showPassword && react_1.default.createElement(next_components_icon_1.default, { id: "Ver", kind: "L", size: 16 }),
                    showPassword && react_1.default.createElement(next_components_icon_1.default, { id: "NoVer", kind: "L", size: 16 })))),
            !isReadOnly && react_1.default.createElement("span", { className: `e-skeletonInput__bar ${barCss}` }),
            error && react_1.default.createElement("div", { className: "e-skeletonInput__error" }, error),
            showInfo && react_1.default.createElement("div", { className: "e-skeletonInput__info" }, info),
            !error && (react_1.default.createElement("div", { className: "e-skeletonInput__description" }, inputDescription || (theme === exports.THEME.FORM ? '\u00A0' : '')))));
    }
}
Input.propTypes = {
    id: prop_types_1.default.string.isRequired,
    isAutocomplete: prop_types_1.default.bool,
    svgIconProps: prop_types_1.default.object,
    theme: prop_types_1.default.oneOf([exports.THEME]),
    colorTheme: prop_types_1.default.oneOf([exports.COLOR_THEME]),
    onChange: prop_types_1.default.func,
    typeField: prop_types_1.default.string,
    name: prop_types_1.default.string,
    autoComplete: prop_types_1.default.string,
    placeHolder: prop_types_1.default.string,
    cleanButton: prop_types_1.default.bool,
    cleanAction: prop_types_1.default.func,
    actionInput: prop_types_1.default.func,
    allowPaste: prop_types_1.default.bool,
    isReadOnly: prop_types_1.default.bool,
    defaultValue: prop_types_1.default.string,
    toggleLabel: prop_types_1.default.bool,
    className: prop_types_1.default.string,
    required: prop_types_1.default.bool,
    minLength: prop_types_1.default.number,
    maxLength: prop_types_1.default.number,
    validators: prop_types_1.default.arrayOf(String),
    error: prop_types_1.default.string,
    taggingInfo: prop_types_1.default.object,
    inputDescription: prop_types_1.default.string,
    pattern: prop_types_1.default.string,
    showHideIcon: prop_types_1.default.bool,
    info: prop_types_1.default.string,
    saveOnChangeValidation: prop_types_1.default.bool,
    formSkeletonProps: prop_types_1.default.shape({
        submitTries: prop_types_1.default.number.isRequired,
        validationTries: prop_types_1.default.number.isRequired,
        activateFormElement: prop_types_1.default.func.isRequired,
        deactivateFormElement: prop_types_1.default.func.isRequired,
        validateFormElement: prop_types_1.default.func.isRequired,
        validateForm: prop_types_1.default.bool.isRequired,
    }),
};
Input.defaultProps = {
    isAutocomplete: false,
    svgIconProps: null,
    theme: exports.THEME.LINE,
    colorTheme: exports.COLOR_THEME.WHITE,
    onChange: null,
    typeField: 'text',
    name: '',
    autoComplete: 'on',
    placeHolder: '',
    cleanButton: false,
    cleanAction: null,
    actionInput: null,
    allowPaste: true,
    isReadOnly: false,
    defaultValue: '',
    toggleLabel: true,
    className: '',
    required: false,
    minLength: null,
    maxLength: null,
    validators: [],
    error: '',
    taggingInfo: {},
    inputDescription: '',
    pattern: null,
    showHideIcon: false,
    info: '',
    saveOnChangeValidation: false,
    formSkeletonProps: null,
};
exports.default = Input;
//# sourceMappingURL=index.js.map